(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tfd-hero-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tfd-hero-gallery')) return;

    class TfdHeroGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tfd-hg__track');
        this.slides = Array.from(this.querySelectorAll('.tfd-hg__slide'));
        this.thumbs = Array.from(this.querySelectorAll('[data-hg-thumb]'));
        this.strip = this.querySelector('[data-hg-thumbs]');
        this.stripWrap = this.querySelector('[data-hg-thumbs-wrap]');
        this.counter = this.querySelector('[data-hg-current]');
        this.toggleBtn = this.querySelector('[data-hg-toggle]');
        this.count = this.slides.length;
        this.current = 0;
        this.pending = null;
        this.pauseReasons = new Set();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && this.count > 1 && !this.reducedMotion;

        if (this.count < 2) return;

        this.bind();
        this.setActive(0, { scrollThumbs: false });
        if (this.autoplay) this.classList.add('is-playing');
        this.updateStripEdges();
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this._onVisibility);
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        if (this._io) this._io.disconnect();
        if (this._ro) this._ro.disconnect();
        if (this._roThumb) this._roThumb.disconnect();
      }

      bind() {
        this.querySelectorAll('[data-hg-prev]').forEach((b) => b.addEventListener('click', () => this.goTo(this.current - 1)));
        this.querySelectorAll('[data-hg-next]').forEach((b) => b.addEventListener('click', () => this.goTo(this.current + 1)));

        this.thumbs.forEach((btn) => {
          btn.addEventListener('click', () => this.goTo(Number(btn.dataset.hgThumb)));
        });

        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.current + 1); }
          if (e.key === 'ArrowLeft')  { e.preventDefault(); this.goTo(this.current - 1); }
        });

        let raf = null;
        this.track.addEventListener('scroll', () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            const w = this.track.clientWidth || 1;
            const idx = Math.round(this.track.scrollLeft / w);
            if (this.pending !== null) {
              if (idx === this.pending) this.pending = null;
              return;
            }
            if (idx !== this.current && idx >= 0 && idx < this.count) this.setActive(idx);
          });
        }, { passive: true });

        this.strip?.addEventListener('scroll', () => this.updateStripEdges(), { passive: true });

        // 自動再生の完了 → 次へ
        this.addEventListener('animationend', (e) => {
          if (e.animationName === 'tfdHgProgress') this.goTo(this.current + 1);
        });

        // 一時停止の条件
        // マウスホバーでは止めない。キーボード操作でフォーカスした時のみ一時停止
        this.addEventListener('focusin', (e) => {
          if (e.target.matches(':focus-visible')) this.pause('focus');
        });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.resume('focus');
        });

        this._onVisibility = () => document.hidden ? this.pause('hidden') : this.resume('hidden');
        document.addEventListener('visibilitychange', this._onVisibility);

        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver(([entry]) => {
            entry.isIntersecting ? this.resume('offscreen') : this.pause('offscreen');
          }, { threshold: 0.25 });
          this._io.observe(this);
        }

        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => {
            this.track.style.scrollBehavior = 'auto';
            this.track.scrollLeft = this.current * this.track.clientWidth;
            this.track.style.scrollBehavior = '';
            this.updateStripEdges();
          });
          this._ro.observe(this.track);

          // 縦長矢印の高さをサムネ画像の高さに合わせる
          const media = this.querySelector('.tfd-hg__thumb-media');
          if (media) {
            this._roThumb = new ResizeObserver(() => {
              this.style.setProperty('--hg-thumb-h', media.offsetHeight + 'px');
            });
            this._roThumb.observe(media);
          }
        }

        this.toggleBtn?.addEventListener('click', () => {
          if (this.pauseReasons.has('user')) {
            this.resume('user');
            this.classList.remove('is-user-paused');
            this.toggleBtn.setAttribute('aria-label', 'Pause slideshow');
          } else {
            this.pause('user');
            this.classList.add('is-user-paused');
            this.toggleBtn.setAttribute('aria-label', 'Play slideshow');
          }
        });

        // テーマエディタ：ブロック選択時にそのスライドを表示
        this._onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i === -1) return;
          this.pause('editor');
          this.goTo(i, { instant: true });
        };
        this._onBlockDeselect = (e) => {
          if (this.slides.includes(e.target)) this.resume('editor');
        };
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
      }

      goTo(index, { instant = false } = {}) {
        const i = (index + this.count) % this.count;
        this.setActive(i);
        const left = i * this.track.clientWidth;
        if (Math.abs(this.track.scrollLeft - left) < 2) { this.pending = null; return; }
        this.pending = i;
        clearTimeout(this._pendingTimer);
        this._pendingTimer = setTimeout(() => { this.pending = null; }, 1200);
        this.track.scrollTo({ left, behavior: instant || this.reducedMotion ? 'auto' : 'smooth' });
      }

      setActive(i, { scrollThumbs = true } = {}) {
        this.current = i;

        this.slides.forEach((s, idx) => {
          const active = idx === i;
          s.classList.toggle('is-active', active);
          s.inert = !active;
        });

        this.thumbs.forEach((t, idx) => {
          const active = idx === i;
          t.classList.toggle('is-active', active);
          if (active) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });

        // 進捗バーのアニメーションをリスタート
        const bar = this.thumbs[i]?.querySelector('.tfd-hg__thumb-progress');
        if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }

        if (this.counter) this.counter.textContent = i + 1;
        if (scrollThumbs) this.scrollThumbIntoView(i);
      }

      scrollThumbIntoView(i) {
        const t = this.thumbs[i];
        if (!t || !this.strip) return;
        const left = t.offsetLeft - (this.strip.clientWidth - t.offsetWidth) / 2;
        this.strip.scrollTo({ left: Math.max(0, left), behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }

      updateStripEdges() {
        if (!this.strip || !this.stripWrap) return;
        const max = this.strip.scrollWidth - this.strip.clientWidth;
        this.stripWrap.classList.toggle('can-left', this.strip.scrollLeft > 4);
        this.stripWrap.classList.toggle('can-right', this.strip.scrollLeft < max - 4);
      }

      pause(reason) {
        this.pauseReasons.add(reason);
        this.classList.add('is-paused');
      }

      resume(reason) {
        this.pauseReasons.delete(reason);
        if (this.pauseReasons.size === 0) this.classList.remove('is-paused');
      }
    }

    customElements.define('tfd-hero-gallery', TfdHeroGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
